export default {
	async getAllServices() {
		return await this.asyncRequest('get', '/api/services');
	},

	async getService(id) {
		return await this.asyncRequest('get', `/api/services/${id}`);
	},

	async getAllMembers() {
		return await this.asyncRequest('get', '/api/members');
	},

	async getCalendarBookings(startDate, endDate, status) {
		return await this.asyncRequest('get', '/api/me/calendar/bookings', {
			params: { start_date: startDate, end_date: endDate, status }
		});
	},

    async getAllMemberLeaves(startTime, endTime) {
		return await this.asyncRequest('get', '/api/members/all_leaves', {
			params: { start_time: startTime, end_time: endTime }
		});
	},

    async getMemberLeaves(memberUserId, startTime, endTime) {
		return await this.asyncRequest('get', '/api/members/' + memberUserId + '/leaves', {
			params: { start_time: startTime, end_time: endTime }
		});
	},

    async getAllMemberExtraHours(startTime, endTime) {
		return await this.asyncRequest('get', '/api/members/all_extra_hours', {
			params: { start_time: startTime, end_time: endTime }
		});
	},

    async getMemberExtraHours(memberUserId, startTime, endTime) {
		return await this.asyncRequest('get', '/api/members/' + memberUserId + '/extra_hours', {
			params: { start_time: startTime, end_time: endTime }
		});
	},

    async getAllServiceLeaves(startTime, endTime) {
		return await this.asyncRequest('get', '/api/services/all_leaves', {
			params: { start_time: startTime, end_time: endTime }
		});
	},

    async getAllServiceExtraHours(startTime, endTime) {
		return await this.asyncRequest('get', '/api/services/all_extra_hours', {
			params: { start_time: startTime, end_time: endTime }
		});
	},

	async getItems(page, keyword, category_ids, status) {
		return await this.asyncRequest('get', '/api/items', {params: {page, keyword, category_ids, status}});
	},

	async getAllItems() {
		return await this.asyncRequest('get', '/api/items/all_items');
	},

	async duplicateItem(itemId) {
		return await this.asyncRequest('post', '/api/items/' + itemId + '/duplicate');
	},

	async duplicateSpec(itemId, specId) {
		return await this.asyncRequest('post', `/api/items/${itemId}/specs/${specId}/duplicate`);
	},

	async saveItem(item, /* array */photoFile) {
		if (item.id) {
			return await this.asyncFormDataRequests('put', '/api/items/' + item.id, item, photoFile);
		} else {
			return await this.asyncFormDataRequests('post', '/api/items', item, photoFile);
		}
	},

	async saveItemSpec(spec, photoFile) {
		if (spec.id) {
			return await this.asyncFormDataRequests('put', `/api/items/${spec.provider_item_id}/specs/${spec.id}`, spec, photoFile);
		} else {
			return await this.asyncFormDataRequests('post', `/api/items/${spec.provider_item_id}/specs`, spec, photoFile);
		}
	},

	async uploadItemImages(itemId, photoFiles) {
		return await this.asyncFormDataRequests('post', '/api/items/' + itemId + '/images', null, photoFiles);
	},
	
	async deleteImage(imageId) {
		return await this.asyncRequest('delete', `/api/images/${imageId}`);
	},

	async deleteSpecImage(itemId, specId) {
		return await this.asyncRequest('delete', `/api/items/${itemId}/specs/${specId}/image`);
	},

	async deleteItemSpec(providerItemId, specId) {
		return await this.asyncRequest('delete', `/api/items/${providerItemId}/specs/${specId}`);
	},

	async createItemGroup(explicit, title, /*array*/ items, rules) { // items: [{item_id: 1}, {item_id:2, spec_id: 3}]) {
		return await this.asyncRequest('post', '/api/item_groups', {is_explicit: !!explicit, title, items, rules});
	},

	async updateItemGroup(groupId, title, /*array*/ items, rules) { // items: [{item_id: 1}, {item_id:2, spec_id: 3}]
		return await this.asyncRequest('put', '/api/item_groups/' + groupId, {title, items, rules});
	},

	async getItemGroup(itemGroupId) {
		return await this.asyncRequest('get', '/api/item_groups/' + itemGroupId);
	},

	async showItem(itemId) {
		return await this.asyncRequest('post', '/api/items/' + itemId + '/visible');
	},

	async hideItem(itemId) {
		return await this.asyncRequest('delete', '/api/items/' + itemId + '/visible');
	},

	async deleteItem(itemId) {
		return await this.asyncRequest('delete', '/api/items/' + itemId);
	},

	async getAllItemGroups() {
		return await this.asyncRequest('get', '/api/item_groups');
	},

	async getExplicitItemGroups() {
		return await this.asyncRequest('get', '/api/item_groups?explicit_only=1', {explicit_only: true});
	},

	async setAutoVisibility({itemId, type, datetime}) {
		return await this.asyncRequest('post', `/api/items/${itemId}/auto_visibility`, {type, datetime});
	},

	async clearAutoVisibility({itemId}) {
		return await this.asyncRequest('delete', `/api/items/${itemId}/auto_visibility`);
	},

	async saveItemGroup(group) {
		if (group.id) {
			return await this.asyncRequest('put', '/api/item_groups/' + group.id, group);
		} else {
			return await this.asyncRequest('post', '/api/item_groups', group);
		}
	},

	async deleteGroup(groupId) {
		return await this.asyncRequest('delete', '/api/item_groups/' + groupId);
	},

	async getAllItemCategories() {
		return await this.asyncRequest('get', '/api/item_categories');
	},

	async saveItemCategory(category) {
		if (category.id) {
			return await this.asyncRequest('put', '/api/item_categories/' + category.id, category);
		} else {
			return await this.asyncRequest('post', '/api/item_categories', category);
		}
	},

	async deleteItemCategory(categoryId) {
		return await this.asyncRequest('delete', '/api/item_categories/' + categoryId);
	},

	async getLoggedInCustomer() {
		return await this.asyncRequest('get', '/api/customer');
	},

	async updateLoggedInCustomer(name, email, unbind_platforms, password, gender, ageGroup, currency) {
		return await this.asyncRequest('put', '/api/customer', {
			name, email, unbind_platforms, password, gender, age_group: ageGroup, currency
		});
	},

	async logOutCustomer() {
		return await this.asyncRequest('post', '/api/customer/logout');
	},

	async verifyAndLogIn({ code, phoneNumber, phoneCallingCode, name, email, password, continueWithoutSmsVerification }) {
		return await this.asyncRequest('post', '/api/customer/verify_and_login', {
			code,
			phone_number: phoneNumber,
			phone_calling_code: phoneCallingCode,
			name,
			email,
			password,
			continue_without_sms_verification: continueWithoutSmsVerification,
		})
	},

	async login(phoneNumber, phoneCallingCode, password) {
		return await this.asyncRequest('post', '/api/customer/login', {
			phone_number: phoneNumber,
			phone_calling_code: phoneCallingCode,
			password
		})
	},

	async getCustomerBookings(page, type) {
		return await this.asyncRequest('get', `/api/customer/bookings?page=${page}&type=${type}`)
	},

	async getGuestBookings(phoneCallingCode, phoneNumber, email, page, type) {
		return await this.asyncRequest('post', `/api/guest/bookings?page=${page}&type=${type}`, {
			phone_calling_code: phoneCallingCode,
			phone_number: phoneNumber,
			email
		})
	},

	async getLogistics() {
		return await this.asyncRequest('get', '/api/logistics');
	},

	async deleteLogistic(id) {
		return await this.asyncRequest('delete', `/api/logistics/${id}`);
	},

	async saveLogistic(logistic) {
		if (logistic.id) {
			return await this.asyncFormDataRequests('put', '/api/logistics/' + logistic.id, logistic);
		} else {
			return await this.asyncFormDataRequests('post', '/api/logistics', logistic);
		}
	},

	async updateOrderLogistic(bookingId, orderId, logistic) {
		return await this.asyncFormDataRequests('put', `/api/bookings/${bookingId}/orders/${orderId}/logistics/${logistic.id}`, logistic);
	},

	async getAvailableOffers() {
		return await this.asyncRequest('get', '/api/available_offers');
	},

	async getOffers(page, type, keyword) {
		return await this.asyncRequest('get', `/api/offers?page=${page}&type=${type}&keyword=${keyword}`);
	},
	async getAllOffers() {
		return await this.asyncRequest('get', '/api/all_offers');
	},

	async deleteOffer(id) {
		return await this.asyncRequest('delete', `/api/offers/${id}`);
	},

	async saveOffer(offer, photoFile) {
		if (offer.id) {
			return await this.asyncFormDataRequests('put', '/api/offers/' + offer.id, offer, photoFile);
		} else {
			return await this.asyncFormDataRequests('post', '/api/offers', offer, photoFile);
		}
	},

	async getFormBuyableAdvancedCap(serviceId, start, end) {
		return await this.asyncRequest('post', '/api/cart/check_form_buyable_advanced_cap', {service_id: serviceId, start, end});
	},

	async getOfferOptions() {
		return await this.asyncRequest('get', '/api/offers/all_options');
	},

	async getOfferStat(offerId) {
		return await this.asyncRequest('get', `/api/offers/${offerId}/stats`);
	},

	// Booking Pass
	async getBookingPasses(page, archived) {
		return await this.asyncRequest('get', `/api/booking_passes?page=${page}&archived=${archived}`);
	},

	async getBookingPassOptions() {
		return await this.asyncRequest('get', '/api/booking_passes/all_options');
	},

	async getCustomersForBookingPass(bookingPassId) {
		return await this.asyncRequest('get', `/api/booking_passes/${bookingPassId}/customers`);
	},

	async saveBookingPass(payload, photoFile) {
		if (payload.id) {
			return await this.asyncFormDataRequests('put', `/api/booking_passes/${payload.id}`, payload, photoFile);
		} else {
			return await this.asyncFormDataRequests('post', '/api/booking_passes', payload, photoFile);
		}
	},

	async saveBookingPassPresets(bookingPass, presets) {
		return await this.asyncRequest('put', `/api/booking_passes/${bookingPass.id}/presets`, { presets });
	},

	async archiveBookingPass(bookingPassId) {
		return await this.asyncRequest('post', `/api/booking_passes/${bookingPassId}/archive`);
	},

	// Notification
	async getNotifications(page, type) {
		return await this.asyncRequest('get', `/api/notifications/?page=${page}&type=${type}`)
	},

	async getNotificationCountByTypes() {
		return await this.asyncRequest('get', `/api/notifications/count_by_types`)
	},

	async markAllNotificaionAsRead() {
		return await this.asyncRequest('post', `/api/notifications/mark_all_as_read`)
	},

	async markNotificaionAsRead(id) {
		return await this.asyncRequest('post', `/api/notifications/${id}/read`);
	},

	async getInterstitials() {
		return await this.asyncRequest('get', '/api/interstitials');
	},

	async deleteInterstitial(id) {
		return await this.asyncRequest('delete', `/api/interstitials/${id}`);
	},

	async saveInterstitial(interstitial, photoFile) {
		if (interstitial.id) {
			return await this.asyncFormDataRequests('put', '/api/interstitials/' + interstitial.id, interstitial, photoFile);
		} else {
			return await this.asyncFormDataRequests('post', '/api/interstitials', interstitial, photoFile);
		}
	},

	async getSystemInterstitials() {
		return await this.asyncRequest('get', '/api/system-interstitials');
	},

	async deleteSystemInterstitial(id) {
		return await this.asyncRequest('delete', `/api/system-interstitials/${id}`);
	},

	async saveSystemInterstitial(interstitial, photoFile) {
		if (interstitial.id) {
			return await this.asyncFormDataRequests('put', '/api/system-interstitials/' + interstitial.id, interstitial, photoFile);
		} else {
			return await this.asyncFormDataRequests('post', '/api/system-interstitials', interstitial, photoFile);
		}
	},


	async getBookingOperationLogs(bookingId) {
		return (await this.asyncRequest('get', '/api/bookings/' + bookingId + '/logs')).data;
	},

	async getPricingRules(entityType, entityId) {
		return await this.asyncRequest('get', `/api/pricing_rules?entity_id=${entityId}&entity_type=${encodeURIComponent(entityType)}`);
	},

	async deletePricingRule(rule) {
		return await this.asyncRequest('delete', `/api/pricing_rules/${rule.id}`);
	},

	async savePricingRule(rule, entityType, entityId) {
		if (rule.id) {
			return await this.asyncRequest('put', `/api/pricing_rules/${rule.id}`, rule);
		} else {
			return await this.asyncRequest('post', '/api/pricing_rules', {...rule, entity_type: entityType, entity_id: entityId});
		}
	},

	async getCampaigns() {
		return await this.asyncRequest('get', '/api/campaigns');
	},

	async getAvailableCampaigns() {
		return await this.asyncRequest('get', '/api/available_campaigns');
	},

	async getInvoices(page) {
		return await this.asyncRequest('get', '/api/invoices?page=' + page);
	},

	async saveCampaign(campaign) {
		if (campaign.id) {
			return await this.asyncFormDataRequests('put', '/api/campaigns/' + campaign.id, campaign);
		} else {
			return await this.asyncFormDataRequests('post', '/api/campaigns', campaign);
		}
	},

	async getYearlyOfferUsage() {
		return await this.asyncRequest('get', '/api/offers/yearly_usage');
	},

	async getGrades() {
		return await this.asyncRequest('get', '/api/misc/grades');
	},

	async fetchGoogleReserveEntities() {
		return await this.asyncRequest('get', `/api/google_reserve_entities`);
	},

	async saveProviderGoogleReserveEntities(site) {
		const payload = {
			...site,
			location: JSON.stringify(site.location),
		}
		if (site.id) {
			return await this.asyncFormDataRequests('put', `/api/google_reserve_entities/${site.id}`, payload);
		} else {
			return await this.asyncFormDataRequests('post', `/api/google_reserve_entities`, payload);
		}
	},

	async deleteGoogleReserveEntities(siteId) {
		return await this.asyncRequest('delete', `/api/google_reserve_entities/${siteId}`);
	},

	async getServiceRelatedBookingPasses(serviceId) {
		return await this.asyncRequest('get', `/api/services/${serviceId}/related_booking_passes`);
	},

	async getCurrencies() {
		return await this.asyncRequest('get', '/api/currencies');
	},

	// Forms
	async getAllForms() {
		return await this.asyncRequest('get', '/api/forms');
	},

	async getForm(id) {
		return await this.asyncRequest('get', `/api/forms/${id}`);
	},

	async createForm(title) {
		return await this.asyncRequest('post', '/api/forms', { title });
	},

	async updateForm(formData) {
		return await this.asyncRequest('put', `/api/forms/${formData.id}`, formData);
	},

	async deleteForm(formId) {
		return await this.asyncRequest('delete', `/api/forms/${formId}`);
	},

	async duplicateForm(formId, title) {
		return await this.asyncRequest('post', `/api/forms/${formId}/duplicate`, { title });
	},

	async toggleFormIsArchived(formId, type) {
		return await this.asyncRequest('post', `/api/forms/${formId}/toggle_archived_at`, { type });
	},

	// Helper
	async asyncRequest(method, url, params) {
		var params = arguments[2] || {};
		params.withCredentials = true;
		return await axios[method](url, params)
	},

	async asyncFormDataRequests(method, url, params, file) {
		var formData = new FormData();
		if (file) {
			if (Array.isArray(file)) {
				for(var i = 0 ; i < file.length ; i++) {
					formData.append("image[]", file[i]);
				}
			} {
				formData.append("image", file);
			}
		}

		for(var k in params) {
			if (params[k] !== null) {
				formData.append(k, params[k]);
			}
		}
		if (method.toLowerCase() === 'put') {
			formData.append('_method', 'put');
			method = 'post';
		}
		return await axios[method](url, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	}

}